import { FLEX_SUMMARY_FAILED, FLEX_SUMMARY_UNAVAILABLE } from "./flexCallSummaryUtils";
import { TRANSCRIPT_SUMMARY_TERMINAL_STATUSES, type TranscriptSummaryStatus } from "./queries";
import type { StepStatus } from "@/providers/ProcessTrackerProvider";

const GENERATING_CALL_SUMMARY_HEADLINE = "Generating call summary";
const GENERATING_CALL_SUMMARY_SUPPORTING_TEXT =
  "You can finalize now. The summary will update this interaction when it's ready.";
const CALL_SUMMARY_FINALIZE_HEADLINE = "Call summary is ready and will save when you finalize.";

export type TranscriptStatusStep = {
  status: StepStatus;
  headline: string;
  supportingText?: string;
};

const generatingSummaryStep = (): TranscriptStatusStep => ({
  status: "processing",
  headline: GENERATING_CALL_SUMMARY_HEADLINE,
  supportingText: GENERATING_CALL_SUMMARY_SUPPORTING_TEXT
});

export const resolveCallTranscriptSummaryStep = (
  status: TranscriptSummaryStatus | null,
  loading = false
): TranscriptStatusStep | null => {
  if (!status) {
    return loading ? generatingSummaryStep() : null;
  }

  switch (status) {
    case "pending":
    case "processing":
      return generatingSummaryStep();
    case "completed":
      return { status: "complete", headline: CALL_SUMMARY_FINALIZE_HEADLINE };
    case "failed":
      return { status: "error", headline: "Call summary unavailable", supportingText: FLEX_SUMMARY_FAILED };
    case "unavailable":
      return {
        status: "error",
        headline: "Call summary unavailable",
        supportingText: FLEX_SUMMARY_UNAVAILABLE
      };
  }
};

export const isTranscriptSummaryTerminal = (status?: string | null): status is TranscriptSummaryStatus =>
  !!status && TRANSCRIPT_SUMMARY_TERMINAL_STATUSES.includes(status as TranscriptSummaryStatus);

export const shouldPollActiveCallTranscript = ({
  enabled,
  callEnded,
  callSid,
  transcriptSummaryStatus
}: {
  enabled: boolean;
  callEnded: boolean;
  callSid?: string | null;
  transcriptSummaryStatus?: string | null;
}): boolean => {
  if (!enabled || !callEnded || !callSid) return false;

  return !isTranscriptSummaryTerminal(transcriptSummaryStatus);
};

export const getFinalizeDescription = (notes: string): string | null => {
  const trimmed = notes.trim();

  return trimmed || null;
};

export const getCategorizerComments = (notes: string, transcriptSummary?: string | null): string | null => {
  const agent = notes.trim();
  const ai = transcriptSummary?.trim();

  if (agent && ai) return `${ai}\n\n${agent}`;
  return agent || ai || null;
};
